import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { TELEGRAM_INTERNAL_VIEW_PERMISSIONS } from 'dashboard/constants/permissions';
import TelegramInternalPageRouteView from './pages/TelegramInternalPageRouteView.vue';
import TelegramInternalQueuePage from './pages/TelegramInternalQueuePage.vue';
import TelegramInternalReportsPage from './pages/TelegramInternalReportsPage.vue';
import TelegramInternalSettingsPage from './pages/TelegramInternalSettingsPage.vue';
import TelegramInternalAuditPage from './pages/TelegramInternalAuditPage.vue';

const meta = {
  permissions: ['administrator', TELEGRAM_INTERNAL_VIEW_PERMISSIONS],
};

const telegramInternalRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/telegram-internal'),
      component: TelegramInternalPageRouteView,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'telegram_internal_queue',
            params: to.params,
          }),
        },
        {
          path: 'queue',
          name: 'telegram_internal_queue',
          meta,
          component: TelegramInternalQueuePage,
        },
        {
          path: 'reports',
          name: 'telegram_internal_reports',
          meta,
          component: TelegramInternalReportsPage,
        },
        {
          path: 'settings',
          name: 'telegram_internal_settings',
          meta,
          component: TelegramInternalSettingsPage,
        },
        {
          path: 'audit',
          name: 'telegram_internal_audit',
          meta,
          component: TelegramInternalAuditPage,
        },
      ],
    },
  ],
};

export default telegramInternalRoutes;
